import React from 'react'
import PropTypes from 'prop-types'

export const Context = React.createContext({})

export const Provider = props => {
  // Initial values are obtained from the props
  const { children } = props

  // Use State to keep the values
  const [loading, setLoading] = React.useState(false)
  const [cartItemsCount, setCartItemsCount] = React.useState(0)
  const [currentRoute, setCurrentRoute] = React.useState('')
  const [pagination, setPagination] = React.useState([])
  const [selectedPayType, setSelectedPayType] = React.useState('')

  // Make the context object:
  const objContext = {
    loading,
    setLoading,
    cartItemsCount,
    setCartItemsCount,
    currentRoute,
    setCurrentRoute,
    pagination,
    setPagination,
    selectedPayType,
    setSelectedPayType,
  }

  // pass the value in provider and return
  return <Context.Provider value={objContext}>{children}</Context.Provider>
}

Provider.propTypes = {
  children: PropTypes.any,
}

export const { Consumer } = Context
